"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payment = void 0;
const react_1 = require("@chakra-ui/react");
const iban_1 = require("iban");
const react_2 = __importDefault(require("react"));
const useLangContext_1 = require("../../../../hooks/useLangContext");
const Text_1 = __importDefault(require("../../../_core/Text"));
const PaymentLink_1 = require("../PaymentLink");
const PaymentQrCode_1 = require("../PaymentQrCode");
const locales_1 = __importDefault(require("./locales"));
const Payment = ({ invoice }) => {
    const { syncLocales } = (0, useLangContext_1.useLangContext)();
    syncLocales(locales_1.default);
    const { allowIbanPayment, publicPaymentUrl } = invoice;
    const publicPaymentId = allowIbanPayment ? invoice.publicPaymentId : null;
    const wallet = allowIbanPayment ? invoice.wallet : null;
    return (react_2.default.createElement(react_1.Flex, { alignItems: "flex-start", gap: "space-16", width: "100%" },
        react_2.default.createElement(react_1.Box, { border: "1px solid", borderColor: "grey.300", flex: 1 },
            react_2.default.createElement(react_1.Box, { bg: "grey.300", padding: "space-8" },
                react_2.default.createElement(Text_1.default, { fontWeight: "weight-500" }, locales_1.default.heading)),
            wallet ? (react_2.default.createElement(react_1.Stack, { padding: "space-8", spacing: "space-6" },
                react_2.default.createElement(Text_1.default, null, locales_1.default.formatString(locales_1.default.iban, {
                    iban: (0, iban_1.printFormat)(wallet.iban),
                })),
                react_2.default.createElement(Text_1.default, null, locales_1.default.formatString(locales_1.default.bic, { bic: wallet.bic })),
                publicPaymentId ? (react_2.default.createElement(Text_1.default, null, locales_1.default.formatString(locales_1.default.label, {
                    publicPaymentId,
                }))) : null,
                react_2.default.createElement(Text_1.default, null, locales_1.default.swiftBic))) : null,
            publicPaymentUrl ? (react_2.default.createElement(PaymentLink_1.PaymentLink, { publicPaymentUrl: publicPaymentUrl })) : null),
        publicPaymentUrl ? (react_2.default.createElement(PaymentQrCode_1.PaymentQrCode, { publicPaymentUrl: publicPaymentUrl })) : null));
};
exports.Payment = Payment;
